import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollToId } from "./useLenis";

const MAX_FRAMES_TO_WAIT = 30;

/**
 * Scrolls to the element named by the URL hash after a route change.
 *
 * React Router does not do this on its own, so links like /products#calculator
 * used to land at the top of the page. Uses scrollToId so the sticky header
 * offset and Lenis smooth scrolling are respected.
 */
export function useHashScroll() {
  const { hash, key } = useLocation();

  useEffect(() => {
    if (!hash) return;

    const id = decodeURIComponent(hash.slice(1));
    let frameId;
    let framesWaited = 0;

    // The target section may mount a frame or two after navigation, so retry
    // for a short while instead of giving up on the first miss.
    const attempt = () => {
      if (document.getElementById(id)) {
        scrollToId(id);
        return;
      }
      if (framesWaited++ < MAX_FRAMES_TO_WAIT) {
        frameId = requestAnimationFrame(attempt);
      }
    };

    frameId = requestAnimationFrame(attempt);
    return () => cancelAnimationFrame(frameId);
    // `key` changes on every navigation, so clicking the same link twice works.
  }, [hash, key]);
}
